<template>
  <a-popover
    v-model="visible"
    trigger="click"
    @visibleChange="change"
    placement="bottomRight"
    overlayClassName="header-notice-wrapper"
    :getPopupContainer="() => $refs.noticeRef.parentElement"
    :autoAdjustOverflow="true"
    :arrowPointAtCenter="true"
    :destroyTooltipOnHide="true"
    :overlayStyle="{ width: '300px', top: '50px' }"
  >
    <template slot="content">
      <a-tabs>
        <a-tab-pane key="1">
          <span slot="tab" class="tabTitle"
            >平台消息<b
              v-if="
                platFormMes.filter(it => {
                  return it.status === 2
                }).length
              "
            ></b
          ></span>
          <a-list>
            <a-list-item v-for="(value, index) in platFormMes" :key="index" class="hover" @click="go(1)">
              <a-list-item-meta :description="value.created_at">
                <p slot="title" class="desc">{{ value.description }}</p>
                <a-badge :dot="value.status === 2" slot="avatar">
                  <a-avatar
                    style="background-color: white"
                    src="https://gw.alipayobjects.com/zos/rmsportal/ThXAXghbEsBCCSDihZxY.png"
                  />
                </a-badge>
              </a-list-item-meta>
            </a-list-item>
          </a-list>
        </a-tab-pane>
        <a-tab-pane key="2">
          <span slot="tab" class="tabTitle"
            >订单消息<b
              v-if="
                orderMes.filter(it => {
                  return it.status === 2
                }).length
              "
            ></b
          ></span>
          <a-list>
            <a-list-item v-for="(value, index) in orderMes" :key="index" class="hover" @click="go(2)">
              <a-list-item-meta :description="value.created_at">
                <p slot="title" class="desc">{{ value.description }}</p>
                <a-badge :dot="value.status === 2" slot="avatar">
                  <a-avatar
                    style="background-color: white"
                    src="https://gw.alipayobjects.com/zos/rmsportal/ThXAXghbEsBCCSDihZxY.png"
                  />
                </a-badge>
              </a-list-item-meta>
            </a-list-item>
          </a-list>
        </a-tab-pane>
        <a-tab-pane key="3">
          <span slot="tab" class="tabTitle"
            >交易消息<b
              v-if="
                tradeMes.filter(it => {
                  return it.status === 2
                }).length
              "
            ></b
          ></span>
          <a-list>
            <a-list-item v-for="(value, index) in tradeMes" :key="index" class="hover" @click="go(3)">
              <a-list-item-meta :description="value.created_at">
                <p slot="title" class="desc">{{ value.description }}</p>
                <a-badge :dot="value.status === 2" slot="avatar">
                  <a-avatar
                    style="background-color: white"
                    src="https://gw.alipayobjects.com/zos/rmsportal/ThXAXghbEsBCCSDihZxY.png"
                  />
                </a-badge>
              </a-list-item-meta>
            </a-list-item>
          </a-list>
        </a-tab-pane>
      </a-tabs>
      <div>
        <a href="/main/message">更多消息</a>
      </div>
    </template>
    <span class="header-notice" ref="noticeRef">
      <a-badge :count="info.user_unread_messages">
        <img src="@/assets/4.png" class="hover" />
      </a-badge>
    </span>
  </a-popover>
</template>

<script>
import { mapState } from 'vuex'
import { userMessage } from '@/api/message'
export default {
  name: 'Tip',
  data() {
    return {
      visible: false,
      platFormMes: [],
      orderMes: [],
      tradeMes: []
    }
  },
  computed: {
    ...mapState({
      info: state => state.user.info
    })
  },
  methods: {
    change(e) {
      if (e) {
        userMessage({ type: 1, user_id: this.info.id, status: 2 }).then(res => {
          this.platFormMes = res.data.data.slice(0, 3)
        })
        userMessage({ type: 2, user_id: this.info.id, status: 2 }).then(res => {
          this.orderMes = res.data.data.slice(0, 3)
        })
        userMessage({ type: 3, user_id: this.info.id, status: 2 }).then(res => {
          this.tradeMes = res.data.data.slice(0, 3)
        })
      }
    },
    go(type) {
      this.$router.push({ name: 'message', params: { type } })
      this.$emit('change')
    }
  },
  mounted() {
    userMessage({ type: 1, user_id: this.info.id, status: 2 }).then(res => {
      this.platFormMes = res.data.data.slice(0, 3)
    })
    userMessage({ type: 2, user_id: this.info.id, status: 2 }).then(res => {
      this.orderMes = res.data.data.slice(0, 3)
    })
    userMessage({ type: 3, user_id: this.info.id, status: 2 }).then(res => {
      this.tradeMes = res.data.data.slice(0, 3)
    })
  }
}
</script>

<style lang="less" scoped>
.desc {
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  margin-bottom: 0;
}
.tabTitle {
  position: relative;
  b {
    position: absolute;
    top: -4px;
    right: -8px;
    width: 8px;
    height: 8px;
    border-radius: 50%;
    background: #f5222d;
  }
}
</style>
